import React from "react";
import style from "./style.module.css";

export interface IFullWidthImageProps {
    imgSrc: string;
    title?: string;
    altText?: string;
}

export function FullWidthImage(props: IFullWidthImageProps) {
    return (
        <section className={style.fullWidthImage}>
            {props.title ? <h3 className={style.title}>{props.title}</h3> : null}
            <img
                className={style.image}
                src={props.imgSrc}
                alt={props.altText}
            />
        </section>
    )
}